<template>
  <div class="auth-container">
    <div class="auth-card-wrapper">
      <themed-card>
        <div class="auth-form">
          <!-- Logo -->
          <div class="auth-logo">
            <img :src="logoUrl" alt="REoptimizer Logo">
          </div>

          <!-- Success Message -->
          <div class="auth-message">
            <div class="auth-message__icon auth-message__icon--success">
              <theme-icon icon="check-circle" type="icons" />
            </div>
            <h1 class="auth-message__title auth-message__title--success">
              Payment Successful!
            </h1>
            <p class="auth-message__text">
              Thank you for your subscription. Your payment was processed successfully.
            </p>
          </div>

          <!-- Action Button -->
          <div class="auth-message__actions">
            <themed-button
              variant="default"
              @click="goToLogin"
            >
              Go to login
            </themed-button>
          </div>
        </div>
      </themed-card>

      <!-- Copyright -->
      <p class="auth-copyright">
        &copy;{{ currentYear }} REoptimizer&reg;, LLC. All rights reserved.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignupSuccess',
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
    logoUrl() {
      return '/img/logos/reoptimizer.webp';
    }
  },
  methods: {
    goToLogin() {
      window.location.href = '/login';
    }
  }
}
</script>
